// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/pages/SchoolWishListNew/SchoolDetail.less
// module id = 1615
// module chunks = 0